import React from "react"
import { Grid } from "@mui/material"
import { DrawerSeeker } from "@ui-seeker/core"

import { isEditUserSettingsWebSupplierGroupDrawer, isOpenUserSettingsWebSupplierGroupDrawer, userSettingsWebSupplierGroupFormData } from "../../@signals"
import WebSupplierGroupDrawerName from "./Name"
import WebSupplierGroupDrawerWebSuppliers from "./WebSuppliers"
import WebSupplierGroupDrawerSubmit from "./Submit"


export default function WebSupplierGroupDrawer() {
	return <DrawerSeeker
		hideActions
		title={isEditUserSettingsWebSupplierGroupDrawer.value ? 'Edit Web Supplier Group' : 'New Web Supplier Group'}
		isOpen={isOpenUserSettingsWebSupplierGroupDrawer.value}
		controller={() => userSettingsWebSupplierGroupFormData.value = {}}
		successText="save"
	>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<WebSupplierGroupDrawerName />
			</Grid>

			<Grid item xs={12}>
				<WebSupplierGroupDrawerWebSuppliers />
			</Grid>

			<Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
				<WebSupplierGroupDrawerSubmit />
			</Grid>
		</Grid>
	</DrawerSeeker>
}